// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile-default-cover[data-v-7b0da3cd]{background:#2c7ba1;background:linear-gradient(91.89deg,#2c7ba1,#6fbede 17.92%,#8fd6eb 36.39%,#92d6e8 54.95%,#54a5c4 81.98%,#195b83 99.89%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
